import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/kitchen')({
  component: () => <Navigate to="/admin/dashboard" replace />,
})